import React, { useEffect, useState } from "react";
import Viewer from "viewerjs/dist/viewer.esm";

import { findMatches, getImageUrl } from "../final-qa/lib/productData";
import { useParams } from "react-router-dom";

let viewer = null;

const ProductMatchGallery = () => {
    const params = useParams();
    const [images, setImages] = useState([]);
    const upc = params.upc;
    const codingWipKey = params.codingWipKey;
    const productId = params.id;

    useEffect(() => {
        async function fetchProducts() {
            const response = await findMatches(upc, codingWipKey);

            if (!response) {
                return;
            }

            const product = response.find((p) => p.productId === productId);

            if (product) {
                setImages(product.images);
            }
        }

        fetchProducts();
    }, []);

    const onLoad = () => {
        if (viewer) {
            viewer.destroy();
        }

        viewer = new Viewer(document.getElementById("image-gallery"), {
            toolbar: {
                zoomIn: 1,
                zoomOut: 1,
                oneToOne: false,
                reset: 1,
                prev: 1,
                play: false,
                next: 1,
                rotateLeft: 1,
                rotateRight: 1,
                flipHorizontal: 1,
                flipVertical: 1,
            },
        });
    };

    return (
        <div className="container">
            <h1>
                CES Product: {upc} - <span className="memo">{productId}</span>
            </h1>
            <ul
                id="image-gallery"
                className="image-gallery"
                onLoad={onLoad}
            >
                {images.map((image, index) => {
                    return (
                        <li key={`${index}of${images.length}`}>
                            <img
                                src={getImageUrl(image.cxHImageAttributeValue)}
                                alt={image.cxhAssetName}
                            />
                            <p className="txt-center">{image.cxhAssetName}</p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ProductMatchGallery;
